import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private token: string | null = null;
  private userId: number | null = null;
  private tokenPromise: Promise<string> | null = null;

  private requestToken(): Promise<string> {
    if (this.tokenPromise) return this.tokenPromise;

    this.tokenPromise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        window.removeEventListener('message', handler);
        reject(new Error('Token not received from Kepler. Open this app via the Kepler nav bar.'));
      }, 10000);

      const handler = (event: MessageEvent) => {
        if (event.data?.type === 'injest-iq:token' && event.data?.token) {
          clearTimeout(timeout);
          window.removeEventListener('message', handler);
          resolve(event.data.token);
        }
      };

      window.addEventListener('message', handler);

      if (window.opener) {
        window.opener.postMessage('injest-iq:ready', '*');
      } else {
        clearTimeout(timeout);
        window.removeEventListener('message', handler);
        reject(new Error('No opener found. Open this app via the Kepler/Rubin nav bar.'));
      }
    });

    return this.tokenPromise;
  }

  async ensureAuth(): Promise<{ token: string; userId: number }> {
    if (this.token && this.userId) {
      return { token: this.token, userId: this.userId };
    }

    const token = await this.requestToken();
    this.token = token;
    const payload = JSON.parse(atob(token.split('.')[1]));
    this.userId = payload.user_id;

    return { token: this.token, userId: this.userId! };
  }
}
